import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form/PanelGridForm";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        FormComponent: (props) => <Form {...props} />,

        Component: (props) => <Component {...props} {...mergedSettings} />,

        name: "insinkerator/content/panel-grid",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            heading: "Panel Grid",
            panels: [],
            selectedCardIndex: 0,
            border: false,
        }),
    };
};

export default createPlugin;
